var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "abs hidden-sm-and-down" }, [
    !_vm.$store.getters.searchBarVisible
      ? _c("div", [
          _c(
            "div",
            {
              staticClass: "myBtn pointer",
              on: {
                "&click": function ($event) {
                  $event.stopPropagation()
                  return _vm.install.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "d-flex align-center" },
                [
                  _c("v-icon", { staticClass: "myWhite" }, [
                    _vm._v("mdi-exit-to-app"),
                  ]),
                  _c("div", { staticClass: "ml-2 appLabel" }, [
                    _vm._v("App speichern"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }